<template lang="pug">
    v-container(class="fill-height pa-0 ma-0" fluid grid-list-sm)
        v-overlay(:value="loading || fileDownloading")
            v-progress-circular(indeterminate size="64")
        template(v-if="permissionFailed")
            v-layout(column justify-center).text-center
                v-icon(size="200") mdi-emoticon-sad-outline
                .headline.font-weight-regular You don't have permission to access
        iframe(:src='src' style='width: 100%; height: 100%; border: 0;' v-else-if="loaded && src")
        template(v-else-if="!loading")
            v-layout(column justify-center).text-center
                v-icon(size="200") mdi-emoticon-sad-outline
                .headline.font-weight-regular Data not found
</template>

<script>
import { sync } from "vuex-pathify";
import get from "lodash/get";

export default {
  name: "FileViewer",
  data() {
    return {
      loaded: false,
      loading: false,
      permissionFailed: false
    };
  },
  computed: {
    fileInfo: sync("app/currentFileViewer"),
    caption: sync("app/toolbarFileViewerCaption"),
    fileDownloading: sync("app/fileDownloading"),
    src() {
      //https://docs.google.com/viewer?srcid=1f08xg1E1oUWWonf3bxiLJqkV_0stRfai&pid=explorer&efh=false&a=v&chrome=false&embedded=true
      if (this.fileInfo && this.fileInfo.gid)
        return `https://docs.google.com/viewer?srcid=${
          this.fileInfo.gid
        }&pid=explorer&efh=false&a=v&chrome=false&embedded=true`;
      else return "";
    }
  },
  mounted() {
    const slug = this.$route.params.id;
    this.permissionFailed = false;
    this.loading = true;
    this.loaded = false;
    this.caption = "";
    this.axios
      .get(`file-info/${slug}`)
      .then(({ data }) => {
        this.fileInfo = data.data;
        this.fileInfo.gid = data.url;
        this.caption = data.data.name;
      })
      .catch(err => {
        this.fileInfo = null;
        if (get(err, "response.status", -1) === 403) {
          this.permissionFailed = true;
        }
      })
      .finally(() => {
        this.loading = false;
        this.loaded = true;
      });
  },
  beforeDestroy() {
    this.fileInfo = null;
    this.fileDownloading = false;
  }
};
</script>

<style scoped></style>
